import { TripBookPrice } from '51trips-frontend-core'

const tripBookPriceConverter = {
  toFirestore: (tripBookPrice: TripBookPrice) => {
    return {
      pages: tripBookPrice.pages,
      price: {
        [tripBookPrice.prices.currency]: tripBookPrice.prices.value
      }
    }
  }
}

export default tripBookPriceConverter
